var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qrcode-stream',{staticClass:"qrcode",on:{"decode":_vm.onDecode}})}
var staticRenderFns = []

export { render, staticRenderFns }